import { render } from "./RegisterUserData.vue?vue&type=template&id=5cbd2ada&scoped=true"
import script from "./RegisterUserData.vue?vue&type=script&lang=js"
export * from "./RegisterUserData.vue?vue&type=script&lang=js"

import "./RegisterUserData.vue?vue&type=style&index=0&id=5cbd2ada&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbd2ada"]])

export default __exports__